module.exports = __webpack_public_path__ + "f348add5704264dd602b6c8ac515c8c6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/popsicle-s.png
// module id = 2712
// module chunks = 0